import { StripeError } from '@stripe/stripe-js';
import { stripe, stripeDecline, stripeFallbackMessage } from 'models/translate';

export const stripeErrors = (error: StripeError) => {
  const declineCode = (error as StripeError & { decline_code?: string }).decline_code;
  if (declineCode) {
    return stripeDecline[declineCode] ?? stripe[declineCode] ?? stripeFallbackMessage;
  }
  if (error.code && stripe[error.code]) {
    return stripe[error.code];
  }
  return stripeFallbackMessage;
};
